import { timestamp } from '@fingermarkglobal/utilities';
import { buildRequest } from '../request';
import { buildTransactionId } from '../utilities';

const buildPayment = ({ amount, config } = {}) => {
  const category = 'Payment';
  const { order, settings } = config;
  const { siteId, storeId, kioskName, referenceType: format, currency } = settings;
  const { orderId } = order;

  const values = { siteId, storeId, kioskName, orderId };

  // https://docs.adyen.com/point-of-sale/make-a-payment
  const body = {
    PaymentRequest: {
      SaleData: {
        SaleTransactionID: {
          TransactionID: buildTransactionId({ format, values }),
          TimeStamp: timestamp(),
        },
      },
      PaymentTransaction: {
        AmountsReq: {
          Currency: currency,
          RequestedAmount: amount,
        },
      },
    },
  };

  return buildRequest({ body, category, config });
};

export { buildPayment };
